import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Comment = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.09499 11.9444L3.65485 12.5496L2.96363 13.5H7.99991C11.0375 13.5 13.4999 11.0376 13.4999 8C13.4999 4.96243 11.0375 2.5 7.99991 2.5C4.96234 2.5 2.49991 4.96243 2.49991 8C2.49991 9.26268 2.92419 10.4234 3.63853 11.3514L4.09499 11.9444ZM2.84612 11.9614L1.57738 13.7059C1.33702 14.0364 1.5731 14.5 1.98174 14.5H7.99991C11.5898 14.5 14.4999 11.5899 14.4999 8C14.4999 4.41015 11.5898 1.5 7.99991 1.5C4.41005 1.5 1.49991 4.41015 1.49991 8C1.49991 9.49098 2.00191 10.8647 2.84612 11.9614ZM4.49988 7C4.49988 6.72386 4.72374 6.5 4.99988 6.5H10.9999C11.276 6.5 11.4999 6.72386 11.4999 7C11.4999 7.27614 11.276 7.5 10.9999 7.5H4.99988C4.72374 7.5 4.49988 7.27614 4.49988 7ZM4.99991 9C4.72376 9 4.49991 9.22386 4.49991 9.5C4.49991 9.77614 4.72376 10 4.99991 10H8.99991C9.27605 10 9.49991 9.77614 9.49991 9.5C9.49991 9.22386 9.27605 9 8.99991 9H4.99991Z"
      />
    </svg>
  )
})

export default Comment
